import React from 'react';
import './Question.css'

const AnswerYes = () => {
    return <div>
        <p>
            Yes, correct, functional programming can avoid run-time errors 
            before execution and also suits parallel processing in 
            multi-threaded environments.
        </p> 
    </div>
}

const AnswerNo = () => {
    return <div>
        <p>
            In addition to facilitating human reasoning, and improving the 
            readability of code, functional programming can also mitigate 
            run-time errors.
        </p> 
    </div>
}

const Answer = (props) => {
    if (props.answer === 'answerYes') {
        return <AnswerYes />
    } else if (props.answer === 'answerNo') {
        return <AnswerNo />
    } else {
        return <p>Please click an answer button above.</p>
    }
}

class QRtErr extends React.Component {
    constructor(props) {
        super(props);
        this.state = {question: 'unanswered'};
    }
    render() {
        return <div className="Question">
            <p>
                Can functional programming reduce run-time errors?
            </p>
            <br/>
            <div>
                <span className="Button Affirmative" 
                onClick={()=> this.setState({question: 'answerYes'})}
                > Yes </span>
                <span className="Button Negative"
                onClick={()=> this.setState({question: 'answerNo'})}                
                >No</span>
            </div>
            <br/>
            <Answer answer={this.state.question} />
        </div>
    }
}

export default QRtErr;


// WEBPACK FOOTER //
// ./src/components/q_rt_err.js